import { render, staticRenderFns } from "./ResetPasswordDialog.vue?vue&type=template&id=841b1ac4"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports